import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { InfoOutlined as InfoOutlinedIcon } from '@material-ui/icons';

import { PROMOTIONS_BEST_OF_NOTICE } from '../../../constants/promotionConfig';

const PromotionsBestOfNotice = ({ compact = false }) => (
    <Box
        mt={compact ? 0.75 : 1}
        mb={compact ? 1 : 1.5}
        px={1.5}
        py={compact ? 1 : 1.25}
        style={{
            backgroundColor: '#F8F9FB',
            border: '1px solid #E8E8E8',
            borderRadius: 8,
        }}
    >
        <Box display="flex" alignItems="flex-start" style={{ gap: 8 }}>
            <InfoOutlinedIcon
                style={{
                    fontSize: compact ? 16 : 18,
                    color: '#6B7280',
                    marginTop: 2,
                    flexShrink: 0,
                }}
            />
            <Typography
                variant="body2"
                style={{
                    color: '#4B5563',
                    fontSize: compact ? 12 : 13,
                    lineHeight: 1.5,
                }}
            >
                {PROMOTIONS_BEST_OF_NOTICE}
            </Typography>
        </Box>
    </Box>
);

export default PromotionsBestOfNotice;
